import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'countDuration',
})

export class CountDurationPipe implements PipeTransform {
  transform(value: number): string {
    if (!value) return '';

    const totalSeconds = Math.round(value);
    const totalMinutes = Math.floor(totalSeconds / 60);
    const hours = Math.floor(totalMinutes / 60);
    const minutes = this.padTime(totalMinutes % 60);
    const seconds = this.padTime(totalSeconds % 60);

    if (hours === 0) {
      return `${totalMinutes}:${seconds}`;
    }

    return `${hours}:${minutes}:${seconds}`;
  }

  private padTime(value: number): string {
    return value.toString().padStart(2, '0');
  }
}
